// import searchGetters from './search/getters'
import subscriptionGetters from './subscriptions/getters'

export default {
  // ...searchGetters,
  ...subscriptionGetters,
}
